export default "__VITE_ASSET__BfY5xnky__"